"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _userUtil = require("../../../util/user-util");

var _hooks = require("../../../hooks");

var _svg = _interopRequireDefault(require("../../svg"));

var _desktopUserNavPopover = _interopRequireDefault(require("./desktop-user-nav-popover"));

var _desktopUserNav = require("./desktop-user-nav.styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var UserNavSection = function UserNavSection(_ref) {
  var activeLink = _ref.activeLink,
      _ref$user = _ref.user,
      user = _ref$user === void 0 ? {} : _ref$user,
      _ref$userFetchState = _ref.userFetchState,
      userFetchState = _ref$userFetchState === void 0 ? 'pending' : _ref$userFetchState,
      _ref$routes = _ref.routes,
      routes = _ref$routes === void 0 ? [] : _ref$routes;
  var noUser = Object.keys(user).length === 0;
  var isPending = userFetchState === 'pending';

  var _usePopover = (0, _hooks.usePopover)(),
      Popover = _usePopover.Popover,
      PopoverAnchorWrapper = _usePopover.PopoverAnchorWrapper,
      popoverProps = _usePopover.popoverProps,
      toggle = _usePopover.toggle,
      anchorRef = _usePopover.anchorRef;

  return /*#__PURE__*/_react["default"].createElement(_desktopUserNav.Wrapper, null, noUser || isPending ? /*#__PURE__*/_react["default"].createElement(_desktopUserNav.SignInLink, {
    isPending: isPending,
    href: "/login"
  }, "Sign In") : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(PopoverAnchorWrapper, {
    ref: anchorRef
  }, /*#__PURE__*/_react["default"].createElement(_desktopUserNav.UserButton, {
    onClick: toggle,
    style: {
      cursor: 'pointer'
    },
    role: "button",
    tabIndex: "0",
    "aria-label": "User Options",
    "aria-haspopup": "dialog",
    "aria-expanded": popoverProps.isOpen,
    popoverOpen: popoverProps.isOpen
  }, (0, _userUtil.userDisplayName)(user), /*#__PURE__*/_react["default"].createElement(_svg["default"], {
    id: "chevron-down",
    width: 14,
    height: 14
  }))), /*#__PURE__*/_react["default"].createElement(Popover, _extends({}, popoverProps, {
    location: "left",
    align: "end"
  }), /*#__PURE__*/_react["default"].createElement(_desktopUserNavPopover["default"], {
    routes: routes,
    activeLink: activeLink
  }))));
};

UserNavSection.propTypes = {
  activeLink: _propTypes["default"].string,
  routes: _propTypes["default"].array,
  user: _propTypes["default"].shape({})
};
var _default = UserNavSection;
exports["default"] = _default;